/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { Fragment } from 'react'
import { observer } from 'mobx-react'
import { GuideImgWrap, GuideWrap } from '@views/Popup/GuidePopup/index.style'

// 캐릭터가 포함된 다이얼로그의 공용 템플릿 컴포넌트
// 필요한 내용은 아래 컴포넌트를 사용하는 곳에서 채워 넣어준다.
// 예) UserPickNullOngoingBetInfo.tsx
interface CharacterDialogProps {
  characterImg?: React.ReactElement
  title?: React.ReactElement
  body?: React.ReactElement
}

export const CharacterDialog: React.FC<CharacterDialogProps> = observer((props: CharacterDialogProps) => {
  const { characterImg, title, body } = props

  return (
    <Fragment>
      <GuideImgWrap>
        <div className="guide-circle">{characterImg}</div>
        {title}
      </GuideImgWrap>
      <GuideWrap>
        {body}
      </GuideWrap>
    </Fragment>
  )
})
